import React, { useEffect, useState } from 'react';
import SalesDashboard from './Sales/SalesDashboard';
import Cookies from 'js-cookie';
import EngDashboard from './Engineer/EngDashboard';
import InventoryDashboard from './Inventory/InventoryDashboard';
import ManagementDashboard from './Management/ManagementDashboard';
import MarketingDashboard from './MarketingDashboard';

const Dashboard = () => {
  const [userVertical, setUserVertical] = useState();

  useEffect(() => {
    const vertical = Cookies.get('userVertical');
    setUserVertical(vertical);
  }, []);
  return (
    <>
      {userVertical === 'Management' && <ManagementDashboard />}
      {userVertical === 'Sales' && <SalesDashboard />}
      {userVertical === 'Operations' && <EngDashboard />}
      {userVertical === 'Inventory' && <InventoryDashboard />}
      {userVertical === 'Marketing' && <MarketingDashboard />}
    </>
  );
};

export default Dashboard;
